import { template as template_b294e7e2a6484cfcb73f964e64995858 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import FilterWrapper from 'eflex/components/filters/filter-wrapper';
import { findBy } from '@eflexsystems/ember-composable-helpers';
import { isPresent } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import Portal from 'ember-stargate/components/portal';
import SearchTag from 'eflex/components/filters/search-tag';
export default class ImageTypeFilter extends Component {
    @tracked
    isDisplayed;
    constructor(){
        super(...arguments);
        this.isDisplayed = Boolean(this.args.imageType);
        this.args.initParam('imageType', this.args.imageType);
    }
    options = [
        {
            label: 'png',
            value: 'png'
        },
        {
            label: 'jpg',
            value: 'jpg'
        },
        {
            label: 'bmp',
            value: 'bmp'
        },
        {
            label: 'pdf',
            value: 'pdf'
        },
        {
            label: 'svg',
            value: 'svg'
        }
    ];
    get imageType() {
        return this.args.getParam('imageType');
    }
    onDisplayedChanged = ()=>{
        this.isDisplayed = !this.isDisplayed;
    };
    onSelected = (imageType)=>{
        this.args.updateParam('imageType', imageType?.value);
    };
    clear = ()=>{
        this.args.updateParam('imageType', null);
    };
    static{
        template_b294e7e2a6484cfcb73f964e64995858(`
    <Portal @target="filter-fields">
      <FilterWrapper
        class="eflex-image-criteria"
        @form={{@form}}
        @label="controls.criteria.imageType"
        @isDisplayed={{this.isDisplayed}}
        @onChecked={{this.onDisplayedChanged}}
        @hasValue={{isPresent this.imageType}}
        @clear={{this.clear}}
        ...attributes
      >
        <@form.element
          @controlType="power-select"
          @options={{this.options}}
          @optionLabelPath="label"
          @onChange={{this.onSelected}}
          @value={{findBy "value" this.imageType this.options}}
        as |el|>
          <el.control
            class="image-type-dropdown sm"
            @searchEnabled={{true}}
            @searchField="label"
          />
        </@form.element>
      </FilterWrapper>
    </Portal>
    <Portal @target="search-badge-tags">
      <SearchTag
        class='imageType'
        @isDisplayed={{@imageType}}
        @text={{@imageType}}
      />
    </Portal>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
